<template>
  <div class="News">
    <div class="banner">
      <PageBanner :bannerObj="bannerObj"></PageBanner>
      <div class="cont wow bounceInUp">
        <ul class="newsUl">
          <li class="newsItem" v-for="(item, index) in companyNewsList" :key="index">
            <router-link :to="
                splicingUrl({
                  base: '/newsDetails?id=' + item.infoId,
                  index: index - 0 + 1 + (companyPageNo - 1) * companyPageSize,
                  type: 'company',
                })
              ">
              <div class="i_time">
                <div class="b_time_a">{{ item.publishTime[0] }}</div>
                <div class="b_time_b">{{ item.publishTime[1] }}</div>
              </div>
              <div class="i_main">
                <div class="m_title textslh">
                  {{ item.infoName }}
                </div>
                <div class="m_desc">
                  {{ item.infoContent }}
                </div>
                <div class="btn_more">查看详情>></div>
              </div>
            </router-link>
          </li>
        </ul>
        <div class="pagination">
          <el-pagination background layout="prev, pager, next"
                         :hide-on-single-page="companyNewsList.length <= companyPageSize" :page-size="companyPageSize"
                         :total="companyTotal" @size-change="getCompanyPage" @current-change="getCompanyPage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageBanner from "../../components/common/pageBanner"
export default {
  name: "News",
  metaInfo () {
    return {
      title: "新闻动态",
      meta: [
        { name: "keywords", content: "广州统计师事务所" },
        { name: "description", content: "广州统计师事务所" },
      ],
    }
  },
  data () {
    return {
      companyNewsList: [],
      companyTotal: 1, // 总数
      companyPageNo: 1, // 当前页
      companyPageSize: 5, // 每页显示条数
      bannerObj: {
        lableZh: "新闻动态",
        lableEn: "NEWS",
        bannerImg: require("../../assets/img/news/banner.jpg"),
      },
    }
  },
  created () {
    this.getInfoManageList()
  },
  mounted () {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init()
    })
  },
  methods: {
    handleCurrentChange (val) {
      console.log(val)
    },
    // 时间拆分
    conversionFun (date) {
      // console.log(date);
      var nDate = new Date(date.replace(new RegExp(/-/gm), "/"))
      // let nDate = new Date(date),
      var y = nDate.getFullYear(),
        m = ("0" + (nDate.getMonth() + 1)).slice(-2),
        d = ("0" + nDate.getDate()).slice(-2)
      // console.log(date)
      return [y + "." + m, d]
    },
    // 获取banner
    async getBanners () {
      let res = await this.$request.getImageAdvertisingList({
        advertisingPosition: "3",
      })
      if (res.code === 200) {
        this.resBanners = []
        res.rows.map((item) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl
        })
        this.resBanners = res.rows
      }
    },
    // url拼接
    splicingUrl ({ base, index, type }) {
      return base + "&index=" + index + "&type=" + type
    },
    // 图片路径拼接
    companyImgSrc (item) {
      return item && item.infoImage
        ? this.$store.state.baseUrl + item.infoImage
        : ""
    },
    //移除html标签
    removeHTMLTag (str) {
      str = str.replace(/(\n)/g, "")
      str = str.replace(/(\t)/g, "")
      str = str.replace(/(\r)/g, "")
      str = str.replace(/<[^>]+>|&[^>]+;/g, "")
      str = str.replace(/\s*/g, "")
      return str
    },
    // 获取新闻资讯
    async getInfoManageList () {
      let _that = this
      let res = await this.$request.getInfoManageList({
        pageNo: this.companyPageNo,
        pageSize: this.companyPageSize,
        infoColumn: "0",
      })
      res.rows.map((val) => {
        val.infoContent = _that.removeHTMLTag(val.infoContent)
        val.publishTime = _that.conversionFun(val.publishTime)
      })
      this.companyNewsList = res.rows
      this.companyTotal = res.total
      // console.log(res);
    },
    async getCompanyPage (page) {
      // 获取第 page 页数据
      // console.log(page);
      this.companyPageNo = page
      this.getInfoManageList()
    },
  },
  components: { PageBanner },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.textslh {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.News {
  width: 100%;
  min-width: $themeMinWidth;
  box-sizing: border-box;
  .banner {
    width: 100%;
  }
  .cont {
    width: $themeMinWidth;
    box-sizing: border-box;
    padding: 0 60px;
    margin: 50px auto;
    border: solid 1px #e8e8e8;
    .newsUl {
      position: relative;
      .newsItem {
        border-bottom: 1px solid #e6e6e6;
        // &:last-child {
        //   border-bottom: none;
        // }
        &:hover a .i_main .m_title {
          color: #406cdd;
        }
        a {
          display: flex;
          padding: 46px 0 30px;
          .i_time {
            width: 80px;
            height: 66px;
            background-color: #f8f8fb;
            text-align: center;
            .b_time_a {
              width: 78px;
              height: 26px;
              line-height: 26px;
              background-color: #406cdd;
              font-size: 16px;
              font-weight: bold;
              color: #ffffff;
            }
            .b_time_b {
              height: 40px;
              line-height: 40px;
              font-size: 24px;
              font-weight: bold;
              color: #333333;
            }
          }
          .i_main {
            width: 980px;
            box-sizing: border-box;
            padding: 0 0 0 70px;
            .m_title {
              font-size: 18px;
              height: 30px;
              line-height: 30px;
              // font-weight: bold;
              color: #333333;
              padding: 0 0 30px 0;
            }
            .m_desc {
              line-height: 24px;
              font-size: 16px;
              color: #666666;
              text-align: justify;
              margin: 0 0 20px 0;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .btn_more {
              float: right;
              font-size: 16px;
              line-height: 26px;
              color: #406cdd;
            }
          }
        }
      }
    }
  }
  .pagination {
    text-align: center;
    padding: 40px 0;
  }
}
</style>
